import type { FaireBrandEntity } from "../../entity_types/brand";

export const onboarding_onfaire_2: FaireBrandEntity = {
  token: "onboarding_onfaire_2",
  type: "brand",
  name: "Brooklyn Candle Studio",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/92f1720de98adede92a4e1ce7abff38652be4359bc4363a724996e08cb676bc0.webp",
  minimumOrderDollars: 100,
  rating: 4.8,
  location: "US",
  tags: ["onboarding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
